const state = {
  currentPagePlan: "",
  accountLimits: {
    byId: {},
    allIds: []
  },
  paymentDetails: {},
  subscribingCurrentAccount: false
};
export default state;